import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';

export class EventsSection extends Component {
  static displayName = EventsSection.name;

  events = [
    {
      title: "Escuela Bíblica de Vacaciones",
      date: "6-10 de Octubre, 2025",
      description: "Descubramos la GRANDEZA de Dios en las COSAS pequeñas.",
      type: "¡EXALTADO!",
      color: "var(--dark-blue)"
    },
    {
      title: "Renovadas - Congreso de Mujeres",
      date: "24-26 Octubre, 2025",
      description: "Un tiempo especial para las mujeres de la iglesia. Conferencias, talleres y momentos de comunión.",
      type: "Renovadas",
      color: "var(--primary-blue)"
    },
    {
      title: "Acierta - Campamento para Varones",
      date: "7-9 Noviembre, 2025",
      description: "Campamento diseñado para fortalecer la fe y la hermandad entre los hombres de la iglesia.",
      type: "Acierta",
      color: "var(--secondary-gold)"
    },
    
  ];

  render() {
    return (
      <section id="events" className="section">
        <Container>
          <h2 className="section-title">Próximos Eventos</h2>
          <Row>
            {this.events.map((event, index) => (
              <Col lg="6" md="6" className="mb-4" key={index}>
                <Card className="event-card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h5 className="card-title" style={{ color: 'var(--dark-blue)' }}>
                        {event.title}
                      </h5>
                      <span 
                        className="badge px-3 py-2" 
                        style={{ 
                          backgroundColor: event.color,
                          color: 'white',
                          borderRadius: '20px',
                          fontSize: '0.8rem'
                        }}
                      >
                        {event.type}
                      </span>
                    </div>
                    <p className="card-text">
                      {event.description}
                    </p>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-calendar-alt me-2" style={{ color: event.color }}></i>
                      <small className="text-muted fw-bold">
                        {event.date}
                      </small>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          
          {/* Grupos */}
          <Row className="mt-5">
            <Col lg="12">
              <h3 className="text-center mb-4" style={{ color: 'var(--dark-blue)' }}>
                Nuestros Grupos
              </h3>
            </Col>
            <Col lg="6" className="mb-4">
              <Card className="h-100">
                <div className="card-body text-center">
                  <i className="fas fa-heart fa-3x mb-3" style={{ color: 'var(--primary-blue)' }}></i>
                  <h5 className="card-title">Grupo de Parejas</h5>
                  <p className="card-text">
                    Un espacio para fortalecer las relaciones matrimoniales 
                    y crecer juntos en la fe.
                  </p>
                  <small className="text-muted">
                    Reuniones: Jueves 7:00 PM
                  </small>
                </div>
              </Card>
            </Col>
            <Col lg="6" className="mb-4">
              <Card className="h-100">
                <div className="card-body text-center">
                  <i className="fas fa-users fa-3x mb-3" style={{ color: 'var(--secondary-gold)' }}></i>
                  <h5 className="card-title">Grupo de Jóvenes</h5>
                  <p className="card-text">
                    Una comunidad vibrante donde los jóvenes pueden 
                    crecer en su relación con Cristo.
                  </p>
                  <small className="text-muted">
                    Reuniones: Sábados 6:30 PM
                  </small>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
